export const aspectRatioStyles = {
  aspectRatio: '16 / 9',
  position: 'relative',
  width: '100%',
};
